const useMedia =  () => {

  //指定された id を id 属性として持つ DOM を渡すと true を返す関数を返す関数
  const _hasId = id => element => element instanceof HTMLElement && element.id === id;

  //指定された className を class 属性として持つ DOM を渡すと true を返す関数を返す関数
  const _hasClass = className => element => element instanceof HTMLElement && element.classList.contains(className);

  //callback が true を返す要素を祖先までさかのぼって検索、存在すれば返し、なければ null を返す
  const _findParent = (callback, child) => {
    //自身がクラスを持っていたら返す
    if (callback(child)) {
      return child;
    }

    //自身が html 要素なら null　を返す
    if (child instanceof HTMLHtmlElement) {
      return null;
    }

    //そうでなければ親を検索
    return _findParent(callback, child.parentElement);
  };

  //モーダルを表示する
  const _showModal = () => {
    //モーダルの取得
    const back = document.getElementById('js-modalWrapper');
    const modal = document.getElementById('mediaModal');

    //モーダルを表示
    if (back && modal) {
      back.style.pointerEvents = '';
      back.classList.add('isDsply');
      modal.classList.add('isDsply');
    }
  };

  //js-modalWrapper
  const _closeModal = () => {
    //モーダルの取得
    const back = document.getElementById('js-modalWrapper');
    const modal = document.getElementById('mediaModal');

    //モーダルを非表示
    if (back && modal) {
      back.style.pointerEvents = 'none';
      back.classList.remove('isDsply');
      modal.classList.remove('isDsply');
    }
  };

  //openModal イベントを発火させる
  const _fireOpenModal = () => {
    //発火
    window.dispatchEvent(new Event('openModal'));

    //モーダル表示
    _showModal();
  };

  //openModal_thumb イベントを発火させる
  const _fireOpenModalThumb = () => {
    //発火
    window.dispatchEvent(new Event('openModal_thumb'));

    //モーダル表示
    _showModal();
  };

  //諸々のクリックイベントを設置する
  const init = () => {
    //画面全体のクリックを検知
    document.addEventListener('click', event => {
      //モーダルを表示するイベントを発火させる(id)
      if (_findParent(_hasId('js-mediaShowButton'), event.target)) {
        _fireOpenModal();
      }

      //class ベースでイベント発火ボタンがクリックされるのか判定
      const hasClassButton = _findParent(_hasClass('js-mediaShowButton'), event.target);

      //モーダルを表示するイベントを発火させる(class)
      if (hasClassButton && hasClassButton.classList.contains('js-thumbnailButton')) {
        _fireOpenModalThumb();
      }
      else if (hasClassButton) {
        _fireOpenModal();
      }

      //モーダルを閉じるイベント(ボタン)
      if (_findParent(_hasClass('modModalClose'), event.target)) {
        _closeModal();
      }

      //モーダル閉じるイベント(背景)
      if (event.target.id === 'js-modalWrapper') {
        _closeModal();
      }

      //画像を選択するボタン
      if (_findParent(_hasClass('modBulkSettingBtn'), event.target) && _findParent(_hasClass('mdClmn'), event.target)) {
        _closeModal();
      }
    });
  };

  //提供
  return {
    init
  };

};

export default useMedia;
